export const styles = {
  container: 'tw-border-solid tw-border tw-border-neutral-300 tw-rounded tw-overflow-hidden tw-w-full',
  header:
    'tw-w-full tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-3 tw-bg-primary-100 tw-cursor-pointer tw-transition-colors focus:tw-outline-none',
  title: 'tw-text-base tw-font-medium tw-text-neutral-800',
  icon: 'tw-text-neutral-500 tw-transition-transform tw-duration-200 tw-ml-auto',
  iconExpanded: 'tw-rotate-180',
  content: 'tw-px-4 tw-py-3 tw-bg-white',
};
